import { LogReplaceRules } from '@lib/interfaces';
import { DataDogCustomConfig } from '@lib/services';

/**
 * ログマスク対象置換ルール（デフォルト）
 */
const logCustomReplaceRules: LogReplaceRules = {
  // ACM会員ログインの際のパスワード
  password: ['.', '*'],
};

/**
 * Datadog（ログ）構成
 *
 * @see {@link DataDogCustomConfig}
 */
export const DATADOG_CONFIG: DataDogCustomConfig = {
  service: 'all:ibx:spa:checkin',
  replaceRules: logCustomReplaceRules,
};
